import { render, staticRenderFns } from "./TableRiskAppraisal592.vue?vue&type=template&id=dac2956e&scoped=true"
import script from "./TableRiskAppraisal592.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal592.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal592.vue?vue&type=style&index=0&id=dac2956e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac2956e",
  null
  
)

export default component.exports